/* cords2-deliver.js - the estimated delivery dates. 16 October 2026.

   The line said `Sweden 1–5 business days · EU 1–7`, typed into each product
   template by hand. Two things wrong with that: it named a country the store
   does not treat as separate, and it made the visitor do the arithmetic.
   Viktor asked for dates, counted from today, and no Sweden.

   WHY A SCRIPT AND NOT LIQUID. sections/cords2-pdp-buy.liquid draws this
   block and is 15,352 characters against the Admin API's 16,384 cap on a
   whole GraphQL document, so it cannot take another line. It can, though,
   print whatever a setting holds, and that section already has a convention
   for a value filled in later: `Reviews of [product]` and `Based on [n]
   reviews`. So the setting holds `Delivered [delivery]` and this fills the
   token. The wording stays in the theme editor where Viktor can change it;
   only the dates are in here.

   THE RULE.

     Ordered before 12:00 CET on a working day, it goes out today. After
     that, or at a weekend, the next working day. Then 1 to 7 days on top.

   Those 7 are CALENDAR days, Viktor's choice on 16 October: a range that
   reads as a range beats one that is arithmetically truer and looks like a
   fortnight. Working days would have turned a 7 day window into 11 on the
   calendar whenever two weekends fell inside it.

   The dispatch day still skips Saturday and Sunday, because nothing leaves
   the warehouse then and a Sunday order honestly reaches the carrier on
   Monday. That is the one working-day rule left and it moves the whole
   window rather than stretching it.

   PUBLIC HOLIDAYS ARE NOT KNOWN TO IT. Midsummer, Christmas and the May
   holidays will all read a day or two optimistic. A real fix is a list of
   dates in a setting, which is worth doing before the December trade.

   STOCKHOLM TIME, NOT THE VISITOR'S. The cutoff is a fact about the
   warehouse, so 12:00 CET has to mean 12:00 in Stockholm whether the page is
   open in Lisbon or Helsinki. Intl gives the date and hour in that zone, and
   the arithmetic is then done in UTC so that adding a day is always adding
   86,400,000 and never falls into a daylight-saving hole.

   IT RECOMPUTES ON RETURN. A phone left open overnight, or a page coming
   back from the back-forward cache, would otherwise still be showing
   yesterday's dates. The original text of each line is kept so the token can
   be filled again from scratch rather than parsed back out. */
(function () {
  if (window.__c2DeliverBound) return;
  window.__c2DeliverBound = true;

  var TOKEN = '[delivery]';
  var ZONE = 'Europe/Stockholm';
  var CUTOFF = 12;
  var FIRST = 1;
  var LAST = 7;
  var DAY = 86400000;

  /* The date and hour as Stockholm has them, whatever the device thinks. */
  function nowThere() {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: ZONE, year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    });
    var o = {};
    f.formatToParts(new Date()).forEach(function (p) {
      if (p.type !== 'literal') o[p.type] = p.value;
    });
    var h = parseInt(o.hour, 10);
    /* h23 should never give 24, but a stale engine can. */
    if (h === 24) h = 0;
    return { y: +o.year, m: +o.month, d: +o.day, h: h };
  }

  function dispatch() {
    var n = nowThere();
    var t = Date.UTC(n.y, n.m - 1, n.d);
    if (n.h >= CUTOFF) t += DAY;
    var wd = new Date(t).getUTCDay();
    while (wd === 0 || wd === 6) { t += DAY; wd = new Date(t).getUTCDay(); }
    return t;
  }

  /* `17–23 October`, or `29 October – 4 November` across a month end. The
     unspaced en dash is the house rule for a numeric range; the spaced one
     is for a range whose sides carry words. */
  function window_() {
    var lang = document.documentElement.getAttribute('lang') || 'en-GB';
    var base = dispatch();
    var a = new Date(base + FIRST * DAY);
    var b = new Date(base + LAST * DAY);
    var ma = a.toLocaleDateString(lang, { month: 'long', timeZone: 'UTC' });
    var mb = b.toLocaleDateString(lang, { month: 'long', timeZone: 'UTC' });
    if (ma === mb) return a.getUTCDate() + '–' + b.getUTCDate() + ' ' + mb;
    return a.getUTCDate() + ' ' + ma + ' – ' + b.getUTCDate() + ' ' + mb;
  }

  /* Every text node holding the token, with what it said to begin with. */
  var lines = [];
  function collect() {
    lines.length = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.cords2'), function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.indexOf(TOKEN) !== -1) lines.push({ node: n, text: n.nodeValue });
      }
    });
  }

  function fill() {
    if (!lines.length) return;
    var text;
    try { text = window_(); } catch (e) { text = null; }
    lines.forEach(function (l) {
      if (text) {
        l.node.nodeValue = l.text.split(TOKEN).join(text);
      } else {
        /* Nothing honest left to say, so the line goes rather than standing
           there reading `Delivered [delivery]`. */
        var el = l.node.parentElement;
        if (el) el.hidden = true;
      }
    });
  }

  collect();
  fill();

  /* 24 October 2026: the bag drawer is re-rendered after every change and
     brings a fresh [delivery] token each time. refresh() picks up new
     tokens and keeps the lines already found. */
  window.cords2Delivery = {
    refresh: function () {
      var keep = lines.filter(function (l) { return document.contains(l.node); });
      collect();
      Array.prototype.push.apply(lines, keep);
      fill();
    }
  };

  window.addEventListener('pageshow', function (e) { if (e.persisted) { collect(); fill(); } });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) fill();
  });
})();